import { Box, Button, InputAdornment, TextField, Typography } from "@mui/material";
import { COLOR } from "../../../../utils/colors";
import { AddOutlined } from "@mui/icons-material";
import { VIEW } from "../../../../utils/breakpoint";
import { useState } from "react";
import { GridSearchIcon } from "@mui/x-data-grid";
import ListRobotTable from "../../robot/list-robot-table";
import { RobotType } from "../../../../hooks/robot/index.type";

export default function ListRobotScreen({
  onCreateNew,
  onHandleEdit,
  onSubmitRobot,
  defaultSelectedRobots
}: {
  onCreateNew?: () => void
  onHandleEdit?: (robotId: string) => void
  onSubmitRobot?: (robots: RobotType[]) => void,
  defaultSelectedRobots?: RobotType[]
}) {
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedRobots, setSelectedRobots] = useState<RobotType[]>(defaultSelectedRobots || [])

  const isDisableNext = false

  const onHandleUpdateSelectedRobot = (robots: RobotType[]) => {
    setSelectedRobots(robots)
  }

  const onHandleNext = () => {
    onSubmitRobot?.(selectedRobots)
  }
  return (
    <Box sx={(theme) => ({
      paddingY: '34px',
      color: COLOR.neutral[900],
      [theme.breakpoints.up(VIEW.PHONE)]: {
        paddingX: '24px',
      },
      [theme.breakpoints.up(VIEW.TABLET)]: {
        paddingX: '44px',
      }
    })}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              sx={{
                fontSize: '24px',
                fontWeight: 600,
                color: COLOR.neutral[900]
              }}
            >
              Robot
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 400,
                color: COLOR.neutral[900],
                opacity: 0.6,
              }}
            >
              List of robots available in the system
            </Typography>
          </Box>
          <Button onClick={() => onCreateNew?.()} variant="outlined" startIcon={<AddOutlined />}>
            Create New
          </Button>
        </Box>
        <Box sx={{ display: 'flex', mt: '20px' }}>
          <TextField
            id="search-store-name"
            variant="outlined"
            size="small"
            placeholder='Search Robot'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              flex: 'auto',
              backgroundColor: 'white',
              height: "40px",
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <GridSearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>
      <ListRobotTable
        defaultSelectedRobots={selectedRobots || defaultSelectedRobots || []}
        search={searchTerm}
        onSelectedChange={(robots) => onHandleUpdateSelectedRobot(robots)}
        onEditRobot={(robot) => onHandleEdit?.(robot.robot_mac)}
      />
      <Box sx={{ display: 'flex', justifyContent: 'end' }}>
        <Button onClick={onHandleNext} variant="contained" disabled={isDisableNext}>Next</Button>
      </Box>
    </Box>
  )
}